var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.loaded)?_c('footer',{attrs:{"id":"main-footer"}},[_c('nav',[_c('a',{attrs:{"href":"https://directories.onepercentfortheplanet.org/profile/1percent-for-the-planet-france","target":"_blank"}},[_c('span',{staticClass:"logo-planet"})]),_c('router-link',{attrs:{"to":{ 
				path: _vm.getPath('Legal'), 
				meta: { lang: _vm.currentLang 
				} }}},[_vm._v(" "+_vm._s(_vm.$t('legaNotice')))])],1)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }